import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const HeroContainer = styled.section`
  height: 90vh;
  min-height: 700px;
  position: relative;
  overflow: hidden;
`;

const Slide = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${props => props.background});
  background-size: cover;
  background-position: center;
  opacity: ${props => (props.active ? 1 : 0)};
  transition: opacity 1s ease-in-out;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.5));
    z-index: 1;
  }
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
  padding: 0 20px;
`;

const HeroTitle = styled.h1`
  font-size: 72px;
  margin-bottom: 20px;
  letter-spacing: 4px;
  font-weight: 300;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
  
  span {
    color: #c4a484;
    font-weight: 400;
  }
  
  @media (max-width: 768px) {
    font-size: 48px;
  }
`;

const HeroSubtitle = styled.p`
  font-size: 20px;
  max-width: 800px;
  margin: 0 auto 30px;
  line-height: 1.8;
  opacity: 0.95;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
`;

const Rating = styled.div`
  margin-top: 30px;
  font-size: 18px;
  
  .stars {
    color: #ffd700;
    font-size: 28px;
    letter-spacing: 5px;
    margin-bottom: 10px;
    text-shadow: 0 2px 4px rgba(0,0,0,0.3);
  }
  
  span {
    color: #c4a484;
    font-size: 16px;
  }
`;

const SlideDots = styled.div`
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 12px;
  z-index: 3;
`;

const Dot = styled.button`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid white;
  background: ${props => props.$active ? 'white' : 'transparent'};
  cursor: pointer;
  padding: 0;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(255,255,255,0.5);
  }
`;

const HeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80',
      title: 'Diamond',
      subtitle: 'The hardest natural material on Earth'
    },
    {
      image: 'https://images.unsplash.com/photo-1605100804763-247f67b3557e?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80',
      title: 'Ruby',
      subtitle: 'The king of gemstones • Passion • Power'
    },
    {
      image: 'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80',
      title: 'Sapphire',
      subtitle: 'Wisdom • Royalty • Cornflower blue'
    },
    {
      image: 'https://images.unsplash.com/photo-1557174361-f5df6c3a3e0a?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80',
      title: 'Emerald',
      subtitle: 'Renewal • Growth • Lush forests'
    },
    {
      image: 'https://images.unsplash.com/photo-1579546929518-9e396f3cc809?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80',
      title: 'Amethyst',
      subtitle: 'Clarity of mind • Regal purple'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <HeroContainer>
      {slides.map((slide, index) => (
        <Slide 
          key={index} 
          background={slide.image} 
          active={index === currentSlide}
        />
      ))}
      
      <HeroContent>
        <HeroTitle>
          The <span>10 Most Demanded</span> Gemstones
        </HeroTitle>
        <HeroSubtitle>
          Discover America's favorite precious stones • Diamond • Ruby • Sapphire • Emerald • 
          Amethyst • Topaz • Pearl • Opal • Garnet • Citrine
        </HeroSubtitle>
        <Rating>
          <div className="stars">★★★★★</div>

        </Rating>
      </HeroContent>

      <SlideDots>
        {slides.map((_, index) => (
          <Dot 
            key={index} 
            $active={index === currentSlide}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </SlideDots>
    </HeroContainer>
  );
};

export default HeroSlider;